var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.254,
    height: 14.254,
    viewBox: "0 0 14.254 14.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11383",
    "data-name": "Group 11383",
    transform: "translate(-888.414 -705.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12989",
    "data-name": "Path 12989",
    d: "M893.282,694.667l1.522-1.522V701.2a.737.737,0,0,0,1.474,0v-8.051l1.522,1.522a.738.738,0,0,0,1.046-1.04l0,0-2.781-2.78a.736.736,0,0,0-1.042,0h0l-2.781,2.78a.737.737,0,1,0,1.04,1.046l0,0Z",
    transform: "translate(0 15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12990",
    "data-name": "Path 12990",
    d: "M901.931,697.018a.738.738,0,0,0-.738.737v5.652h-11.3v-5.652a.737.737,0,0,0-1.474,0v5.9a1.229,1.229,0,0,0,1.229,1.229h11.8a1.229,1.229,0,0,0,1.229-1.229v-5.9A.737.737,0,0,0,901.931,697.018Z",
    transform: "translate(0 15)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.326fdfd522a276e7ee31076fe6ffc2f6.svg";
export { ForwardRef as ReactComponent };